/** @jsxImportSource @emotion/react */
import { useState, useRef } from "react";
import { Card } from "primereact/card";
import { Sidebar } from "../../../shared";
import { Toast } from "primereact/toast";
import { confirmDialog } from "primereact/confirmdialog";
import {
  Boton,
  Titulo,
  Formulario,
  formatFecha,
  accessAPI
} from "../../../shared";

export default function TarjetaNotas({ proceso }) {
  const [notas, setNotas] = useState(proceso.notas || []);
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const [loader, setLoader] = useState(false);

  const toast = useRef(null);

  function confirmarEliminarNota(nota) {
    confirmDialog({
      message: "¿Está seguro que desea eliminar esta nota?",
      header: "Confirmar eliminación",
      icon: "pi pi-exclamation-triangle",
      acceptClassName: "p-button-danger",
      acceptLabel: "Eliminar",
      rejectLabel: "Cancelar",
      accept: () => eliminarNota(nota)
    });
  }

  function eliminarNota(nota) {
    accessAPI(
      "DELETE",
      `admin/proceso/${proceso.id}/nota/${encodeURIComponent(nota.fecha)}`,
      null,
      (respuesta) => {
        setNotas(respuesta);
        toast.current?.show({
          severity: "success",
          summary: "Eliminada",
          detail: "Nota eliminada exitosamente"
        });
      },
      (error) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: error[0]?.msg || "Error al eliminar la nota",
          sticky: true
        });
      }
    );
  }

  function agregarNota(contenidoCampos) {
    setLoader(true);
    accessAPI(
      "POST",
      `admin/proceso/${proceso.id}/nota`,
      { nota: contenidoCampos.nota },
      (respuesta) => {
        setNotas(respuesta);
        setLoader(false);
        setSidebarVisible(false);
        toast.current?.show({
          severity: "success",
          summary: "Éxito",
          detail: "Nota agregada exitosamente"
        });
      },
      (error) => {
        setLoader(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: error[0]?.msg || "Error al agregar la nota",
          sticky: true
        });
      }
    );
  }

  const formularioConfig = {
    secciones: [
      {
        campos: [
          {
            nombre: "nota",
            etiqueta: "Contenido",
            tipoitemformularioid: 11,
            requerido: true
          }
        ]
      }
    ],
    botones: [
      {
        etiqueta: "Agregar nota",
        verde: true,
        callback: agregarNota,
        validar: true
      }
    ]
  };

  return (
    <>
      <Toast ref={toast} position="top-center" />
      <Card>
        <Titulo
          botones={
            <Boton texto negro callback={() => setSidebarVisible(true)}>
              <i className="pi pi-plus" />
            </Boton>
          }
        >
          Notas
        </Titulo>

        {notas.length > 0 ? (
          <div css={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
            {notas.map((nota, index) => (
              <div
                key={index}
                css={{
                  position: "relative",
                  padding: "1rem",
                  paddingRight: "2.5rem",
                  backgroundColor: "var(--principalLight)",
                  borderRadius: "6px",
                  borderLeft: "3px solid var(--principal)"
                }}
              >
                <button
                  type="button"
                  onClick={() => confirmarEliminarNota(nota)}
                  aria-label="Eliminar nota"
                  css={{
                    position: "absolute",
                    top: "0.5rem",
                    right: "0.5rem",
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                    color: "var(--text-color-secondary)",
                    padding: "0.25rem",
                    lineHeight: 1,
                    "&:hover": { color: "var(--rojo)" }
                  }}
                >
                  <i className="pi pi-times" />
                </button>
                <p
                  css={{
                    margin: 0,
                    marginBottom: "0.5rem",
                    whiteSpace: "pre-wrap"
                  }}
                >
                  {nota.texto}
                </p>
                <p
                  css={{
                    margin: 0,
                    fontSize: "0.85rem",
                    color: "var(--text-color-secondary)"
                  }}
                >
                  {nota.usuario} - {formatFecha(nota.fecha)}
                </p>
              </div>
            ))}
          </div>
        ) : (
          <p css={{ color: "var(--grisTextos)" }}>No hay notas registradas</p>
        )}
      </Card>

      <Sidebar
        visible={sidebarVisible}
        onHide={() => setSidebarVisible(false)}
        position="right"
        className="w-full lg:w-30rem md:w-30rem"
      >
        <Titulo>Nueva nota</Titulo>
        <Formulario config={formularioConfig} loader={loader} />
      </Sidebar>
    </>
  );
}
